// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__cpQ7k","label":"Radio_label__xjP7I","checkMark":"Radio_checkMark__2YRVM","disabled":"Radio_disabled__28BR_"};